import type { LoaderFunctionArgs, MetaFunction } from '@remix-run/node'
import { json } from '@remix-run/node'
import Cal, { getCalApi } from '@calcom/embed-react'
import { useEffect } from 'react'
import { CirclesBackground } from '#app/components/ui/circles-background.tsx'

export const meta: MetaFunction = () => {
	return [
		{ title: 'See LeafAdmin in Action — Book Your Live Demo | LeafAdmin' },
		{
			property: 'og:title',
			content: 'See LeafAdmin in Action — Book Your Live Demo | LeafAdmin',
		},
		{
			name: 'description',
			content:
				'In this short demo, you will see how LeafAdmin can automate your website, optimize your sales team, and unlock real-time analytics.',
		},
	]
}

export default function AboutRoute() {
	useEffect(() => {
		;(async function () {
			const cal = await getCalApi({ namespace: 'leafadmin-demo' })
			cal('ui', {
				theme: 'dark',
				cssVarsPerTheme: {
					light: { 'cal-brand': '#292929' },
					dark: { 'cal-brand': '#fafafa' },
				},
				hideEventTypeDetails: false,
				layout: 'month_view',
			})
		})()
	}, [])

	return (
		<main className="relative mx-auto w-full max-w-7xl px-6">
			<div className="pb-24 pt-16 sm:pb-32 sm:pt-24 md:pb-48 md:pt-32">
				<CirclesBackground
					width="1090"
					height="1090"
					className="absolute -top-7 left-1/2 -z-10 h-[788px] -translate-x-1/2 stroke-gray-300/30 [mask-image:linear-gradient(to_bottom,white_20%,transparent_75%)] sm:top-9 sm:h-auto"
				/>
				<h1 className="mx-auto max-w-6xl text-pretty text-center text-4xl font-bold">
					See LeafAdmin in Action — Book Your Live Demo
				</h1>
				<p className="mx-auto mb-8 mt-6 max-w-3xl text-center text-xl/7 font-medium text-primary/60">
					Stop guessing, start growing. In this short demo, you'll see how
					LeafAdmin can automate your website, optimize your sales team, and
					unlock real-time analytics — so you can focus on{' '}
					<span className="text-primary">scaling your brand.</span>
				</p>
				<Cal
					namespace="leafadmin-demo"
					calLink="bradw/leafadmin-demo"
					style={{ width: '100%', height: '100%', overflow: 'scroll' }}
					config={{ layout: 'month_view' }}
				/>
				<CirclesBackground
					width="1090"
					height="1090"
					className="absolute -bottom-7 left-1/2 -z-10 h-[788px] -translate-x-1/2 stroke-gray-300/30 [mask-image:linear-gradient(to_top,white_20%,transparent_75%)] sm:bottom-5 sm:h-auto"
				/>
			</div>
		</main>
	)
}
